import React from "react";
import { CSSTransition } from "react-transition-group";
import { PDFDownloadLink } from "@react-pdf/renderer";
import Icon from "icons";
import classNames from "classnames";
import { useSelector } from "store/hooks";
import { ResultPdf } from "pages/result";
import Button from "components/button";
import prettierNumber from "utils/prettier-number";
import styles from "./result-box.module.scss";
import modalStyles from "./modals/recommendation.module.scss";
import Modal from "./modals/recommendation";
import Loading from "components/loading";
import {
  getOcrStatusClassName,
  getOcrStatusText,
  isOcrProcessing,
} from "hooks";

const ResultBox = () => {
  const contextApplication = useSelector((state) => state.application);

  const [recommendationModal, setRecommendationModal] = React.useState(false);

  // const handleOpenRecommendation = () => setRecommendationModal(true);

  const selectedRecommendation = React.useMemo(() => {
    return contextApplication.data?.recommendations_log?.find(
      (rec) => rec.id === contextApplication.data?.selected_recommendation
    );
  }, [
    contextApplication.data?.selected_recommendation,
    contextApplication.data?.recommendations_log,
  ]);

  const ocrLog = contextApplication.data?.ocr_log;

  return (
    <div className={styles.resultList}>
      {contextApplication.data?.selected_recommendation && (
        <div className={styles.recommendationBox}>
          <div className={styles.recommendationBox_title}>
            Выбранная рекомендация
          </div>
          <div className={styles.item}>
            <div className={styles.key}>Сумма</div>
            <div className={styles.key}>
              {prettierNumber(selectedRecommendation?.amount ?? 0)} ₸
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.key}>Длительность</div>
            <div className={styles.key}>
              {selectedRecommendation?.duration} мес.
            </div>
          </div>
          <div className={styles.item}>
            <div className={styles.key}>Вероятность выплаты</div>
            <div className={styles.key}>
              {Number(selectedRecommendation?.good_prob) * 100} %
            </div>
          </div>
        </div>
      )}
     <div className={styles.resultBox}>
  <div className={styles.resultBox_title}>Статус заявки</div>

  {ocrLog !== null && (
    <div className={styles.finalResult}>
      {isOcrProcessing(ocrLog) ? (
        <div className={styles.loading}>
          <Loading />
        </div>
      ) : (
        <Icon
          size={120}
          name={ocrLog?.is_approved ? "tickCircle" : "closeFilled"}
          className={getOcrStatusClassName(ocrLog, styles)}
        />
      )}
      <div
        className={classNames(
          styles.finalResultText,
          getOcrStatusClassName(ocrLog, styles)
        )}
      >
        {isOcrProcessing(ocrLog)
          ? getOcrStatusText(ocrLog)
          : contextApplication.data?.selected_recommendation
          ? "Пройден по рекомендации"
          : getOcrStatusText(ocrLog)}
      </div>
    </div>
  )}

  <div className={styles.resultBox_resultText}>
    <div className={styles.item}>
      <div className={styles.key}>ПКБ:</div>

      <div
        className={classNames(
          styles.value,
          getOcrStatusClassName(ocrLog, styles)
        )}
      >
        {getOcrStatusText(ocrLog, "compact")}
      </div>
    </div>
  </div>

  {ocrLog !== null && (
    <PDFDownloadLink
      fileName={"кредитная-заявка-" + contextApplication.data?.id}
      document={<ResultPdf contextApplication={contextApplication} />}
    >
      <Button
        color="blue"
        pending={isOcrProcessing(ocrLog)}
      >
        Скачать результат
      </Button>
    </PDFDownloadLink>
  )}
</div>
      <CSSTransition
        in={!!recommendationModal}
        timeout={150}
        unmountOnExit
        classNames={{
          enter: modalStyles.modalEnter,
          enterActive: modalStyles.modalEnterActive,
          exit: modalStyles.modalExit,
          exitActive: modalStyles.modalExitActive,
        }}
      >
        <Modal
          application={contextApplication.data}
          onClose={() => setRecommendationModal(false)}
        />
      </CSSTransition>
    </div>
  );
};

export default ResultBox;
